import React from 'react';
import { Input, Form, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';

import Modal from 'components/antdCustom/Modal';
import useAPILoading from 'hooks/useAPILoading';
import { apiCreateRequestHelp } from 'APIService/util';
const { TextArea } = Input;

const ModalRequestHelp = (props) => {
  const { closeModal, transaction } = props;
  const { t } = useTranslation();
  const [callHelp, loadingCallHelp] = useAPILoading(apiCreateRequestHelp);

  const onRequestHelp = (form) => {
    const { message } = form;
    if (!message) return;
    callHelp(message, transaction.id).then((response) => {
      notification.success({
        message: response.data.message,
        placement: 'bottomRight',
      });
      closeModal();
    });
  };

  return (
    <Modal
      width='700px'
      title='REQUEST HELP FOR THIS TRANSACTION'
      visible
      okButtonProps={{
        form: 'request-help-form',
        key: 'submit',
        htmlType: 'submit',
      }}
      okText={loadingCallHelp ? <LoadingOutlined /> : undefined}
      onCancel={closeModal}>
      <Form id='request-help-form' layout='vertical' onFinish={onRequestHelp}>
        <Input
          style={{ marginBottom: '20px' }}
          addonBefore={t('transactionId')}
          disabled
          value={transaction && transaction.id}></Input>
        <Form.Item
          name='message'
          rules={[{ required: true, message: t('error:emptyRequestHelp') }]}>
          <TextArea showCount maxLength={300} rows={8}></TextArea>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalRequestHelp;
